"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _Checkbox = _interopRequireDefault(require("./Checkbox.style"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _constants = require("./constants");
var _excluded = ["checkedLabel", "disabled", "name", "checked", "showLabel", "uncheckedLabel", "className", "onChange", "tabIndex", "value", "id", "type", "label", "hasError", "placeholder"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Checkbox = /*#__PURE__*/function (_PureComponent) {
  _inherits(Checkbox, _PureComponent);
  var _super = _createSuper(Checkbox);
  function Checkbox() {
    var _this;
    _classCallCheck(this, Checkbox);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (event) {
      var checked = event.target.checked;
      if (_this.props.onChange) {
        _this.props.onChange(event, checked);
      }
    });
    return _this;
  }
  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        checkedLabel = _this$props.checkedLabel,
        disabled = _this$props.disabled,
        name = _this$props.name,
        checked = _this$props.checked,
        showLabel = _this$props.showLabel,
        uncheckedLabel = _this$props.uncheckedLabel,
        className = _this$props.className,
        onChange = _this$props.onChange,
        tabIndex = _this$props.tabIndex,
        value = _this$props.value,
        id = _this$props.id,
        type = _this$props.type,
        label = _this$props.label,
        hasError = _this$props.hasError,
        placeholder = _this$props.placeholder,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var icon = checked ? _constants.ICON_CHECKED : _constants.ICON_UNCHECKED;
      var switchLabel = checked ? checkedLabel : uncheckedLabel;
      return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], _extends({
        type: type,
        onChange: this.handleInputChange,
        className: "checkbox-wrapper",
        disabled: disabled,
        checked: checked,
        hasError: hasError
      }, otherProps), /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        disabled: disabled,
        name: name,
        id: id,
        checked: checked,
        className: className,
        tabIndex: tabIndex,
        value: value,
        placeholder: placeholder,
        readOnly: true
      }), type === _constants.checkboxTypes.normal ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: "checkbox-icon",
        icon: icon
      }), label && /*#__PURE__*/_react["default"].createElement("span", {
        className: "checkbox-label"
      }, label)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "checkbox-thumb"
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "checkbox-switch-label"
      }, showLabel ? switchLabel : '')));
    }
  }]);
  return Checkbox;
}(_react.PureComponent);
Checkbox.propTypes = {
  showLabel: _propTypes["default"].bool,
  checkedLabel: _propTypes["default"].string,
  uncheckedLabel: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(R.keys(_constants.checkboxTypes)),
  label: _propTypes["default"].string,
  hasError: _propTypes["default"].bool,
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  /**
   * The css classes for the checkbox element
   */
  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * The id of the `checkbox` element.
   */
  id: _propTypes["default"].string,
  /*
   * The name attribute of the checkbox element
   */
  name: _propTypes["default"].string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes["default"].func,
  /**
   * The tab index of the checkbox element
   */
  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /**
   * The value of the component.
   */
  value: _propTypes["default"].string,
  placeholder: _propTypes["default"].string
};
Checkbox.defaultProps = {
  showLabel: false,
  checkedLabel: 'Yes',
  uncheckedLabel: 'No',
  type: _constants.checkboxTypes.normal,
  checked: undefined,
  className: undefined,
  disabled: false,
  id: undefined,
  name: undefined,
  onChange: null,
  tabIndex: null,
  value: undefined,
  label: undefined,
  hasError: false,
  placeholder: undefined
};
Checkbox.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleInputChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Checkbox",
  "props": {
    "showLabel": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "checkedLabel": {
      "defaultValue": {
        "value": "'Yes'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "uncheckedLabel": {
      "defaultValue": {
        "value": "'No'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "checkboxTypes.normal",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "enum",
        "computed": true,
        "value": "R.keys(checkboxTypes)"
      },
      "required": false
    },
    "checked": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "If `true`, the component is checked.",
      "type": {
        "name": "union",
        "value": [{
          "name": "bool"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "The css classes for the checkbox element",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "string"
          }
        }]
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If `true`, the switch will be disabled.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "id": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "The id of the `checkbox` element.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "name": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Callback fired when the state is changed.\r\n\r\n@param {object} event The event source of the callback\r\n@param {boolean} checked The `checked` value of the switch",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "tabIndex": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "The tab index of the checkbox element",
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "The value of the component.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "label": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "hasError": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "placeholder": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = Checkbox;
exports["default"] = _default;